export default __webpack_public_path__ + "static/media/section1-bg1.05ab10ae.png";